import {
    fetchGetCreditCardDocuments,
    GetCreditCardDocumentsResponse
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useFetchCreditCardDocumentsMetadata = () => {
    const stateKey = useStateKey();

    const { data } = useQuery({
        queryKey: ['credit-card-documents-metadata', stateKey],
        queryFn: async () => {
            const responseData = await fetchGetCreditCardDocuments({
                stateKey
            });
            return responseData as GetCreditCardDocumentsResponse;
        },
        suspense: true,
        select: (response: GetCreditCardDocumentsResponse) =>
            response.data.documents
    });

    return data;
};
